/**
 * The `--cf-*` tokens {@link OfferTiles} reads, mapped onto the section colour-scheme vars.
 *
 * The tiles were born inside the COD order form and read ITS design tokens. Anywhere else — the standalone
 * `volume-tiers` block, and since feature 0069 the catalog-mode buy-box — there is no form around them, so
 * without this mapping they would fall back to cod-form's greens on a shop that never chose them.
 *
 * Shared rather than copied (0069 lot B): two copies of a colour map drift, and the drift shows up as a
 * buy-box whose tiles are the wrong accent on exactly the stores that do not use the COD form.
 */
export const OFFER_TILE_VARS = {
    '--cf-text': 'var(--aqx-scheme-text, #1b1b1e)',
    '--cf-muted': 'color-mix(in srgb, var(--aqx-scheme-text, #1b1b1e) 55%, transparent)',
    '--cf-accent': 'var(--aqx-scheme-accent, #5a34b8)',
    '--cf-accent-tint': 'color-mix(in srgb, var(--aqx-scheme-accent, #5a34b8) 12%, transparent)',
    '--cf-soft': 'color-mix(in srgb, var(--aqx-scheme-accent, #5a34b8) 12%, transparent)',
    '--cf-border': 'var(--aqx-scheme-border, #e4e4e9)',
    '--cf-surface': 'var(--aqx-scheme-surface, #f3f3f3)',
    '--cf-input-bg': 'var(--aqx-scheme-bg, #ffffff)',
    '--cf-radius': '12px',
};
//# sourceMappingURL=offerTileVars.js.map